<template>
  <div :class="wrapperClasses">
    <div
      v-if="partialPage"
      class="progress-spinner-wrapper-partial-overlay"
    ></div>

    <div class="spinner-content">
      <TSpinner
        :class="tokenClasses"
        :data-testid="name && `${kebabCase(name)}-spinner`"
        :name="name"
        v-bind="$attrs"
      />
      <div class="loading-message">
        <transition name="fade" mode="out-in">
          <span :key="`ai-msg-${currentIndex}`" class="loading-message-inner">
            {{ currentMessage }}
          </span>
        </transition>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import TSpinner from '../TSpinner.vue'
import { setup } from './controller'
import { T_SPINNER_WITH_MESSAGES_PROPS } from './types'

export default defineComponent({
  name: 'TMSpinnerWithMessages',
  components: { TSpinner },
  props: T_SPINNER_WITH_MESSAGES_PROPS,
  setup,
})
</script>

<style scoped lang="scss">
.spinner-content {
  @apply flex flex-col items-center relative;
  z-index: 1;
}

.loading-message {
  @apply mt-3 text-base text-nash-neutral700;
  min-height: 1.5rem;
  text-align: center;
  transition: opacity 300ms ease-in-out;
}

.loading-message-inner {
  @apply block;
  line-height: 1.5rem;
}

/* simple fade transition */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.progress-spinner-wrapper-partial-overlay {
  @apply absolute inset-y-0 inset-x-0;
  background: rgba(255, 255, 255, 0.75);
}

.progress-spinner-wrapper {
  @apply fixed top-1/2 left-1/2;
  z-index: 999;
}

.progress-spinner-wrapper::before {
  @apply fixed block opacity-50 top-0 left-0 w-full h-full bg-nash-neutral000;
  content: '';
}

.progress-spinner-wrapper-partial {
  @apply absolute inset-y-0 inset-x-0 flex items-center justify-center overflow-hidden;
  z-index: 999;
}
</style>
